module.exports = __webpack_public_path__ + "static/media/5.7f1100c1.jpg";